import SceneView from './SceneView.jsx';
import { EL_TRAIT, GROUP_LABEL } from '../lib/rules.js';
import { topElements } from '../lib/temper.js';
import { sajuProfile } from '../lib/profile.js';

const STEM_EL = ['목', '목', '화', '화', '토', '토', '금', '금', '수', '수'];

// 사주 신분증: 동물 초상 + 원국 요약 + 코드 두 줄. 공유 카드의 바탕이 된다.
export default function IdCard({ run }) {
  const { saju, birth } = run;
  const [y, m, d] = saju.solarDate.split('-');
  const tops = topElements(saju.elements);
  const topStat = Object.entries(saju.stats).sort((a, b) => b[1] - a[1])[0];
  const profile = sajuProfile(saju);
  const who = birth?.gender === 'F' ? '여' : '남';
  const hour = birth?.hour == null ? '모름' : `${birth.hour}시 ${String(birth.minute ?? 0).padStart(2, '0')}분`;
  return (
    <section className="idcard">
      <div className="idhead"><span>사주 신분증</span><span>{y}</span></div>
      <div className="idbody">
        <div className="idphoto"><SceneView saju={saju} portrait /><span className="idphoto-caption">{saju.day.text}일주</span></div>
        <dl className="iddl">
          <dt>일주</dt><dd className="idbig">{saju.day.text}일주</dd>
          <dt>성별</dt><dd>{who}</dd>
          <dt>출생</dt><dd>{y}.{m}.{d} (음력 {saju.lunarDate})</dd>
          <dt>시각</dt><dd>{hour}</dd>
          <dt>기질</dt><dd>{tops.map((el) => EL_TRAIT[el]).join(' · ')}</dd>
          <dt>가장 높은 영역</dt><dd>{GROUP_LABEL[topStat[0]]} {topStat[1]}</dd>
          <dt>나(일간)</dt><dd>{STEM_EL[saju.day.stem]} 기운</dd>
          {profile?.gyeok && (<><dt>격국</dt><dd>{profile.gyeok.name}</dd></>)}
        </dl>
      </div>
      <div className="idcard-edge" aria-hidden="true"><span /><span /><span /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /></div>
    </section>
  );
}
